module.exports = __webpack_public_path__ + "static/fonts/GourmetHearth.5eaec03.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GourmetHearth.otf
// module id = 237
// module chunks = 1